import { render, staticRenderFns } from "./HelpdeskCategories.vue?vue&type=template&id=207f681e&scoped=true"
import script from "./HelpdeskCategories.ts?vue&type=script&lang=ts&external"
export * from "./HelpdeskCategories.ts?vue&type=script&lang=ts&external"
import style0 from "./HelpdeskCategories.vue?vue&type=style&index=0&id=207f681e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f681e",
  null
  
)

export default component.exports